export default {"src":"/_next/static/media/real-time-monitoring.67f32b1c.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};